/**
 * User KYC country must be an explicit ISO-3 choice.
 * Do not default to ZAF / South Africa. Blank is invalid.
 */

export const KYC_COUNTRY_REQUIRED_MESSAGE = 'Select your country of residence. It cannot be left blank.'

export function normalizeKycCountryCode(value) {
  return String(value || '').trim().toUpperCase()
}

export function isExplicitKycCountry(code, name) {
  const countryCode = normalizeKycCountryCode(code)
  const countryName = String(name || '').trim()
  return /^[A-Z]{3}$/.test(countryCode) && countryName.length > 0
}

export function requireKycCountry(kycData) {
  const src = kycData && typeof kycData === 'object' ? kycData : {}
  if (!isExplicitKycCountry(src.country_code, src.country_name)) {
    return { ok: false, error: KYC_COUNTRY_REQUIRED_MESSAGE }
  }
  return {
    ok: true,
    country_code: normalizeKycCountryCode(src.country_code),
    country_name: String(src.country_name).trim(),
  }
}
